import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Shield, Award } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Fleet & Equipment', path: '/fleet' },
    { name: 'Safety & Compliance', path: '/safety' },
    { name: 'Broker Setup', path: '/broker-setup' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const services = [
    'Dry Van Freight',
    'Reefer Freight',
    'Flatbed Transport',
    'Power-Only',
    'Box Truck',
    'Expedited Freight',
  ];

  return (
    <footer className="bg-[#020617] text-white" data-testid="footer">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img src="/logo.jpeg" alt="Douala Express Inc" className="h-12 w-auto rounded-sm" />
              <div>
                <span className="text-white font-bold text-xl tracking-tight font-['Montserrat']">
                  DOUALA EXPRESS
                </span>
                <span className="block text-[#FFD700] text-xs tracking-widest uppercase">
                  Inc.
                </span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Precision Logistics. Nationwide Reach. Trusted freight transportation services across all 48 states since 2014.
            </p>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-[#FFD700]">
                <Shield className="h-5 w-5" />
                <span className="text-xs font-semibold">FULLY INSURED</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6 font-['Montserrat']">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-[#FFD700] transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6 font-['Montserrat']">
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-slate-400 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Compliance */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6 font-['Montserrat']">
              Contact & Compliance
            </h4>
            <div className="space-y-4">
              <a
                href="tel:773-344-7748"
                className="flex items-center space-x-3 text-slate-400 hover:text-[#FFD700] transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="h-4 w-4" />
                <span className="text-sm">773-344-7748</span>
              </a>
              <a
                href="mailto:dispatch.douala@gmail.com"
                className="flex items-center space-x-3 text-slate-400 hover:text-[#FFD700] transition-colors"
                data-testid="footer-email"
              >
                <Mail className="h-4 w-4" />
                <span className="text-sm">dispatch.douala@gmail.com</span>
              </a>
              <div className="flex items-start space-x-3 text-slate-400">
                <MapPin className="h-4 w-4 mt-0.5" />
                <span className="text-sm">Nationwide Coverage - 48 States</span>
              </div>
            </div>

            {/* Compliance Box */}
            <div className="mt-6 bg-[#0B2A5B] p-4 rounded-sm border-l-4 border-[#FFD700]">
              <div className="flex items-center space-x-2 mb-2">
                <Award className="h-4 w-4 text-[#FFD700]" />
                <span className="text-xs font-bold uppercase tracking-wider text-white">
                  Federal Authority
                </span>
              </div>
              <div className="space-y-1 text-sm">
                <p className="text-slate-300">
                  <span className="text-[#FFD700] font-semibold">USDOT:</span> 2520499
                </p>
                <p className="text-slate-300">
                  <span className="text-[#FFD700] font-semibold">MC:</span> 874923
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} Douala Express Inc. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Fully Licensed & Insured Nationwide Freight Carrier
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
